<script>
    import { createEventDispatcher, onMount } from 'svelte'
    import { Typography } from '.'
    import { Information } from '../Icons'
    import { now } from '../../stores/device'
    import { slide } from 'svelte/transition'
    import { urlPattern, clickOutside, getRelTime } from '$lib/utils'
    import createChatStore from '../../stores/chat_store'
    import { fly } from 'svelte/transition'

    export let title = ''
    export let data = []
    export let message = ''
    export let placeholder = ''
    export let selfId = null
    export let showContext = false
    export let showFrom = false
    export let header = true
    export let disabled = false
    export let messages = createChatStore({ messages: data })
    export let disabledMsg = 'No puedes responder a este chat.'
    export let alt = null

    const dispatch = createEventDispatcher()
    let box

    function getMessageBody(msg) {
        return [...msg.matchAll(urlPattern)]
            .map(([x]) => x)
            .reduce(
                (r, c) =>
                    r.replace(c, `<a href="${c}" target="_blank">${c}<a/>`),
                msg
            )
    }

    function scrollToBottom() {
        setTimeout(() => {
            if (box) box.scrollTo(0, box.scrollHeight)
        }, 2)
    }

    onMount(() => {
        scrollToBottom()
    })

    messages.callback = () => {
        scrollToBottom()
    }
    $: data = $messages
</script>

<div class="container" class:header>
    {#if header}
        <div class="head">
            <span style="display: flex; gap: 15px; align-items: center">
                <slot name="beforeTitle" />
                <Typography
                    type="h4"
                    style="margin: 0; padding: 0"
                    color="white">{title || 'Untitle'}</Typography
                >
            </span>
            {#if $$slots.context}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <span
                    title={alt}
                    class:active={showContext}
                    class="toggle-context"
                    on:click={() => (showContext = !showContext)}
                >
                    <Information size={20} color="#ffffff" />
                </span>
            {/if}
        </div>
    {/if}
    {#if $$slots.context && showContext}
        <div
            use:clickOutside
            on:clickout={() => {
                setTimeout(() => {
                    showContext = false
                }, 1)
            }}
            transition:slide|local={{}}
            class="context"
            style={!header ? 'top: 0px' : ''}
        >
            <slot name="context" />
        </div>
    {/if}
    <div class="content" bind:this={box}>
        {#if $messages?.length && $$slots}
            {#each $messages as message (message.order)}
                {@const me = selfId && message?.from === selfId}
                <span
                    in:fly|local={{ x: me ? 50 : -50, delay: 100 }}
                    title={me ? 'Yo' : message?.from}
                    class="message"
                    class:me
                    class:pending={message.status == 'pending'}
                >
                    {#if !me && showFrom}
                        <p class="author">{message.from}</p>
                    {/if}
                    <span>
                        {@html getMessageBody(message?.value)}
                    </span>
                    {#if message?.date instanceof Date}
                        <i title={message.date.toString()}
                            >{getRelTime(message.date, $now)}</i
                        >
                    {/if}
                </span>
            {/each}
        {:else}
            <div
                style="display: flex; align-items: center; justify-content: center;width: 100%; height: 100%"
            >
                <slot />
            </div>
        {/if}
    </div>
    <div class="typer">
        {#if $$slots.field}
            <slot name="field" />
        {:else if !disabled}
            <input
                {placeholder}
                {disabled}
                type="text"
                bind:value={message}
                on:keypress={(e) => {
                    let { key } = e
                    if (key == 'Enter') {
                        if (message !== '') {
                            let tmpMessage = messages.insert({
                                value: message,
                                from: selfId,
                            })
                            dispatch('message', {
                                targetEvent: e,
                                message: tmpMessage,
                                store: messages,
                            })
                        }
                        message = ''
                    }
                }}
            />
        {:else}
            <span
                style="width: 100%; display: flex; margin: auto; justify-content: center"
            >
                <Typography type="caption" color="grey-400"
                    >{disabledMsg}</Typography
                >
            </span>
        {/if}
    </div>
</div>

<!-- // const messages = writable(data instanceof Array ? // Ajuste de datos
    //     data.map(
    //         m => (
    //             {
    //                 ...m,
    //                 date: m.date instanceof Date ? m.date : getDateObj(m?.date),
    //                 id: m?.id || hashString(m),
    //             }
    //         )
    //     )
    //     .sort((a, b) => a?.date > b?.date ? 1 : -1)
    //     : []
    // ) -->

<style>
    :root {
        --head-height: 63px;
    }
    .container {
        display: grid;
        grid-template-rows: 0px fr 50px;
        /* grid-template-rows: 55px 1fr 50px; */
        height: 100%;
        width: 100%;
        min-width: 200px !important;
        gap: 0;
        position: relative;
        /* background-color: antiquewhite; */
    }
    /* .container div { */
    /* } */
    .head {
        position: relative;
        display: flex;
        padding: 15px 20px;
        align-items: center;
        justify-content: space-between;
        grid-row: 1;
        background-color: var(--color-brand-primary-01);
    }
    .content {
        position: relative;
        display: flex;
        flex-direction: column;
        grid-row: 2;
        padding: 15px;
        overflow-y: scroll;
        overflow-x: hidden;
        scroll-behavior: 'smooth';
        background-color: var(--color-grey-100);
    }

    .toggle-context {
        background-color: rgba(255, 255, 255, 0.1);
        cursor: pointer;
        border-radius: 5px;
        padding: 0 3px;
        transition: background-color 0.25s ease-in-out;
    }

    .toggle-context.active,
    .toggle-context:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }

    .context {
        /* display: block; */
        width: 100%;
        min-height: calc(50%);
        height: auto;
        position: absolute;
        z-index: 999;
        background-color: white;
        top: var(--head-height);
        padding: 15px;
        box-shadow: 0px 12px 9px -8px rgba(0, 0, 0, 0.34);
    }
    .typer {
        justify-content: center;
        grid-row: 3;
        border-top: 1px #c0c0c0 solid;
        background-color: white;
    }

    .message {
        display: flex;
        position: relative;
        height: auto;
        padding: 12px 12px 20px 12px;
        max-width: 75%;
        min-width: 135px;
        height: auto;
        text-wrap: stable;
        align-self: flex-start;
        margin: 15px 0 0 15px;
        color: var(--color-black);
        border-radius: 5px 10px 20px 10px;
        background: var(--color-white);
        box-shadow: var(--shadow-hover);
        flex-direction: column;
        transition: opacity 0.15s ease-in-out;
    }
    .message p.author {
        font-size: 15px;
        font-weight: 600;
        margin: 0 0 2px 0;
        color: var(--color-brand-primary-01);
    }
    .message i {
        font-size: 11px;
        font-style: normal;
        opacity: 0.5;
        position: absolute;
        bottom: 5px;
        right: 10px;
        user-select: none;
    }
    .me {
        align-self: flex-end;
        background-color: var(--color-brand-primary-01);
        border-radius: 10px 5px 10px 20px;
        color: white;
    }
    /* .me a { color: white } */
    /* .sending {
        opacity: 0.89;
    } */
    .pending {
        opacity: 0.65;
    }
    input[type='text'] {
        background-color: inherit;
        border-style: none;
        padding: 15px 5px;
        text-indent: 15px;
        width: 100%;
        outline: none;
    }

    .header {
        grid-template-rows: var(--head-height) 1fr 50px !important;
    }
</style>
